function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState, useEffect } from 'react';
import { iconValid } from '../../helpers';
import { StyledToggle, Track, ToggleInput, FormikInput } from './styles';
import _ from 'lodash';
const Toggle = props => {
  const {
    theme,
    selectedTheme,
    form,
    name,
    icon,
    iconColor,
    inactiveColor,
    activeColor,
    localDefault,
    callback,
    ...rest
  } = props;
  const defaultValue = name && form?.values[name] || localDefault || false;
  const [checked, setChecked] = useState(defaultValue);
  useEffect(() => {
    if (!_.isEqual(defaultValue, checked)) {
      setChecked(defaultValue);
    }
  }, [defaultValue, checked]);
  const handleFieldStateUpdate = e => {
    const newValue = e.currentTarget.checked;
    if (form && name) form.setFieldValue(name, newValue);
    callback?.(newValue);
    setChecked(!checked);
  };
  return /*#__PURE__*/React.createElement(StyledToggle, null, form && /*#__PURE__*/React.createElement(FormikInput, _extends({
    type: "checkbox",
    name: name,
    $theme: theme,
    $selectedTheme: selectedTheme,
    form: form,
    checked: checked,
    onChange: handleFieldStateUpdate
  }, rest)), !form && /*#__PURE__*/React.createElement(ToggleInput, _extends({
    type: "checkbox",
    name: name,
    $theme: theme,
    $selectedTheme: selectedTheme,
    checked: checked,
    onChange: handleFieldStateUpdate
  }, rest)), /*#__PURE__*/React.createElement(Track, {
    $theme: theme,
    $selectedTheme: selectedTheme,
    checked: checked,
    $activeColor: activeColor,
    $inactiveColor: inactiveColor,
    $iconColor: iconColor,
    disabled: rest.disabled
  }, /*#__PURE__*/React.createElement("i", {
    className: iconValid(icon) || 'fa-solid fa-circle'
  })));
};
export { Toggle };